import React from "react";

function Banner() {
  return (
    <div style={{ margin: "0 auto", display: "flex" }}>
      <div style={{ padding: 20, flex: 0.5, backgroundColor: "#E72129" }}>
        <br />
        <h1 style={{ color: "white", fontWeight: "bold" }}>Banner</h1>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>

      <div
        class="second"
        style={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <div style={{ backgroundColor: "#FF9898", flex: 1 }}></div>
        <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
          <div style={{ backgroundColor: "#FFBABA", flex: 1 }}></div>
          <div style={{ backgroundColor: "#FFE9E9", flex: 1 }}></div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
